import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChild, ElementRef, Renderer2, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResumeDetailService } from './resume-detail.service';
import { MessageService } from '../../../core/services/message.service';
import { LoginUserService } from '../../../core/services/login-user.service';
import { IMAGE_BASE__URL } from '../../../core/services/CusHttp';


@Component({
  selector: 'app-resume-detail',
  templateUrl: './resume-detail.component.html',
  styleUrls: ['./resume-detail.component.scss'],
})
export class ResumeDetailComponent implements OnInit, AfterViewInit {
  @Input() detail_id: any;
  @Input() position_id: any; //岗位id
  @Input() resume_id: any; //简历id
  // @Input() collectPerson: boolean = false; //判断是否显示加入人才库的按钮
  @Input() handle: any = ''; //判断是否显示处理的按钮
  @Output() handletype: any = new EventEmitter(); //处理简历类型
  @Output() showDownload: any = new EventEmitter(); //处理简历类型
  public token: string;
  IMAGE_BASE__URL = IMAGE_BASE__URL;

  showInviteDialog = false;
  inviteTime: any = '';

  resumeDetail: any = {};  //简历详情
  type: any; //简历处理  1待处理；2：待沟通；3：不合适
  isAddPerson: boolean; //判断是否加入人才库
  ishandle: boolean; //判断是否已经处理过简历
  display: boolean = false;  //是否显示模态框
  posttype: any = ""; //岗位列表    公司是否发布 0未发布；1发布了 ，不传获取所有类型
  postList: any = []; //获取岗位列表
  selectedPost: any; //找人才页面  加入人才库时 选择的岗位
  isselect: any; //模态框中选择的岗位
  loginInfo: any; //登录信息
  isLogin: boolean; //判断是否登录
  stuid: any; //学生id
  issend: boolean; //是否已经发送面试邀请
  @Input() isdisplay: boolean;


  constructor(
    // private _renderer: Renderer2,
    private _route: ActivatedRoute,
    private _handleService: MessageService,
    private _service: ResumeDetailService,
    private _loginService: LoginUserService
  ) {
    this.token = this._loginService.getToken();
    this._loginService.token$.subscribe((resp: string) => {
      this.token = resp;
    });
  }

  ngOnInit() {
    //  判断登录状态 获取企业id
    this.isLogin = this._loginService.isLogin();
    if (this.isLogin) {
      this.loginInfo = this._loginService.getLoginInfo();
    }

    this.position_id = this.position_id;
    this.resume_id = this.resume_id;
    //获取简历详情
    this.getResumeDetail();
    //判断是否加入人才库
    this.isAdd();


  }

  ngAfterViewInit() {

  }

  showInvite() {
    this.showInviteDialog = true;
    console.log(1234);
  }

  getResumeDetail() {
    //获取简历详情
    this._service.getResumeDetail(this.resume_id).then(data => {
      this.resumeDetail = data['data'];
      this.resume_id = data['data']['hopejob']['resume_id'];
      this.stuid = data['data']['student']['id'];
      //判断是否已经邀请面试
      this.isInvite();
      //年龄转化
      this.resumeDetail.student.birthday = (new Date().getFullYear()) -
        (new Date(data['data']['student']['birthday']).getFullYear());
    });
  }

  //判断是否加入人才库 企业id  简历id
  isAdd() {
    this._service.isCollect(this.loginInfo.company_id, this.resume_id).then(res => {
      this.isAddPerson = res['data']['data'];
    });
  }

  //判断是否已经邀请面试
  isInvite() {
    this._service.isSend(this.stuid).then(data => {
      this.issend = data['data']['type'];
    });
  }

  //加入人才库
  addperson() {
    this._service.addTalentPool(this.position_id, this.resume_id).then(data => {
      if (data['data']['type']) {
        this._handleService.success('已加入人才库！');
        setTimeout(() => {
          this._handleService.clear();
        }, 3000);
        this.isAddPerson = false;
        this.isAdd();
      } else {
        this._handleService.warn(data['data']['message']);
        setTimeout(() => {
          this._handleService.clear();
        }, 3000);
      }
    });
  }

  //面试邀约
  invite() {
    this._service.sendInvite(this.stuid, this.position_id, this.inviteTime).then(data => {
      if (data['data']['type']) {
        this._handleService.success(data['data']['message']);
        setTimeout(() => {
          this._handleService.clear();
        }, 3000);
        this.issend = true;
        this.showInviteDialog = false;
        this.isInvite();
      } else {
        this._handleService.warn(data['data']['message']['student']);
        setTimeout(() => {
          this._handleService.clear();
        }, 3000);
      }

    });
  }

  //跳转待沟通、不合适    delivery_status  0 待处理；1已查看；2：待沟通；3：不合适
  gotoWait(status: any) {
    this._service.ismarkResume(this.detail_id, status).then(data => {
      this.handle = status;
      this.ishandle = false;
      this._handleService.success('操作成功！');
      setTimeout(() => {
        this._handleService.clear();
      }, 3000);
      this.handletype.emit(status);

    });
  }

  // // 打开模态框
  // showdialog() {
  //      //先判断是否有岗位信息
  //      this._service.getComPost( this.loginInfo.company_id ).then( data => {
  //       if ( data[ 'data' ] && data[ 'data' ].length ) {
  //         this.postList = data[ 'data' ];
  //         this.display = true;
  //       } else {
  //         this._handleService.warn( '暂无岗位信息，请您先发布岗位信息！' );
  //         setTimeout(() => {
  //           this._handleService.clear();
  //         }, 3000 );
  //       }
  //     } );

  // }

  // //打开模态框选择岗位
  // selectPost( id: any ) {
  //   let a = this.postList.find( row => row.id === id );
  //   this.isselect = a;
  //   this.position_id = id;
  // }


  // //选择确定关闭模态框
  // definepost() {

  //   if ( this.position_id ) {
  //     // this.addperson();   调面试邀约接口
  //     this.isselect = null;
  //     this.position_id = null;
  //     this.display = false;
  //     this.getResumeDetail();
  //   } else {
  //     this._handleService.warn( '请选择要邀请的岗位！' );
  //     setTimeout(() => {
  //       this._handleService.clear();
  //     }, 3000 );
  //   }
  // }

  // //获取企业的岗位信息 参数：岗位id    公司是否发布 0未发布；1发布了 ，不传获取所有类型
  // // this.posttype
  // getPostList() {
  //   this._service.getComPost( this.loginInfo.company_id ).then( data => {
  //     if ( data[ 'data' ] && data[ 'data' ].length ) {
  //       this.postList = data[ 'data' ];
  //     }
  //   } );

  // }
  //简历预览
  targetIsOpen() {
    this.isdisplay = true;
    this.showDownload.emit(this.isdisplay);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/company/resume-detail/resume-detail.component.ts